import { AppThunk } from "../store";
import {
  setFilterRoleUpdateStatus,
  setFilterRoleOptionsRequestStatus,
  setFilterRoleOptions,
  setFilterRole,
  setFilterRoleRequestStatus,
  setMembersUpdateStatus,
  setFilterRoleCreationStatus,
  setFilterRoleDeletionStatus,
  setSwitchMemberStatus,
} from ".";
import { RequestStatus as Status } from "constants/RequestStatus";

import { filterRoleService } from "services/filterRoleService";
import { FilterRole } from "types/FilterRole";
import { profileService } from "services/profileService";
import { ServiceOptions } from "services/baseService";
import { User } from "types/User";
import { userService } from "services/userService";
import { setFilterRoleMembers, setNonFilterRoleMembers } from "store/user";

export const getRolesAsFilterOptions = (): AppThunk => async (dispatch) => {
  try {
    const options: ServiceOptions = {
      order: [["id", "ASC"]],
    };
    dispatch(setFilterRoleOptionsRequestStatus(Status.Loading));
    const { data: roles } = await filterRoleService.getAll(options);

    const roleOptions = roles.map((role: FilterRole) => ({
      id: role.id || 0,
      name: role.name,
      description: role.description,
      membersCount: role.membersCount || 0,
    }));
    dispatch(setFilterRoleOptions(roleOptions));
    dispatch(setFilterRoleOptionsRequestStatus(Status.Success));
  } catch (error) {
    dispatch(setFilterRoleOptionsRequestStatus(Status.Failed));
  }
};

export const getFilterRoleByID =
  (id: number): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setFilterRoleRequestStatus(Status.Loading));
      const { data } = await filterRoleService.getById(id);
      dispatch(setFilterRole(data));
      dispatch(getAllFilterRoleMembersByID(id));
      dispatch(getNonFilterRoleMembersByID(id));
      dispatch(setFilterRoleRequestStatus(Status.Success));
    } catch (error) {
      dispatch(setFilterRoleRequestStatus(Status.Failed));
    }
  };

export const getAllFilterRoleMembersByID =
  (roleId: number): AppThunk =>
  async (dispatch) => {
    try {
      const options: ServiceOptions = {
        include: ["Profile"],
        order: [["id", "ASC"]],
      };
      const { data: users } = await userService.getAll(options);
      const members: User[] = [];
      users.forEach((user) => {
        if (user.profile) {
          if (user.profile.filterRoleId === roleId) members.push(user);
        }
      });
      dispatch(setFilterRoleMembers(members));
    } catch (error) {
      console.error(error);
    }
  };

export const getNonFilterRoleMembersByID =
  (id: number): AppThunk =>
  async (dispatch) => {
    try {
      const { data } = await filterRoleService.getNonMembers(id);
      dispatch(setNonFilterRoleMembers(data));
    } catch (error) {
      console.error(error);
    }
  };

export const createNewFilterRole =
  (bodyData: FilterRole): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setFilterRoleCreationStatus(Status.Loading));
      await filterRoleService.create(bodyData);
      dispatch(getRolesAsFilterOptions());
      dispatch(setFilterRoleCreationStatus(Status.Success));
    } catch (error) {
      dispatch(setFilterRoleCreationStatus(Status.Failed));
    }
  };

export const addMembersToFilterRoleByIDs =
  (filterRoleId: string | number, membersIds: number[]): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setMembersUpdateStatus(Status.Loading));
      await profileService.addFilterRoleMembers(filterRoleId, membersIds);
      dispatch(getFilterRoleByID(Number(filterRoleId)));
      dispatch(setMembersUpdateStatus(Status.Success));
    } catch (error) {
      dispatch(setMembersUpdateStatus(Status.Failed));
    }
  };

export const swicthFilterRoleMemberByIDs =
  (currentRoleId: number, newRoleId: number, memberId: number): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setSwitchMemberStatus(Status.Loading));
      await profileService.addFilterRoleMembers(newRoleId, [memberId]);
      dispatch(getFilterRoleByID(currentRoleId));
      dispatch(setSwitchMemberStatus(Status.Success));
    } catch (error) {
      dispatch(setSwitchMemberStatus(Status.Failed));
    }
  };

export const updateFilterRole =
  (id: number, bodyData: FilterRole): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setFilterRoleUpdateStatus(Status.Loading));
      const { data } = await filterRoleService.update(id, bodyData);
      dispatch(setFilterRole(data));
      dispatch(setFilterRoleUpdateStatus(Status.Success));
    } catch (error) {
      dispatch(setFilterRoleUpdateStatus(Status.Failed));
    }
  };

export const deleteFilterByRoleID =
  (id: number): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setFilterRoleDeletionStatus(Status.Loading));
      await filterRoleService.delete(id);
      dispatch(getRolesAsFilterOptions());
      dispatch(setFilterRoleDeletionStatus(Status.Success));
    } catch (error) {
      dispatch(setFilterRoleDeletionStatus(Status.Failed));
    }
  };
